import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { PortfolioItemModel } from '../portfolio-item.model';
import { AppCommunicationService } from '../../../../services/app-communication.service';
import { LibtukePortfolioService } from '../libtuke-portfolio.service';
import { ConfirmationService } from "primeng";
import { first } from "rxjs/operators";

@Component({
  selector: 'smart-list-portfolio',
  templateUrl: './list-portfolio.component.html',
  styleUrls: ['./list-portfolio.component.scss']
})
export class ListPortfolioComponent implements OnInit {

  table = {
    columns: [],
    page: 1,
    pageSize: 30,
    totalItems: 0
  };

  data: PortfolioItemModel[] = [];

  @Output() editItemEvent: EventEmitter<PortfolioItemModel> = new EventEmitter<PortfolioItemModel>();

  constructor(
    private appCommunication: AppCommunicationService,
    private portfolioService: LibtukePortfolioService,
    private confirmation: ConfirmationService
  ) {
  }

  ngOnInit() {
  }

  setPage(pageInfo) {
    this.table.page = (pageInfo.first + pageInfo.rows) / this.table.pageSize;
    this.loadData();
  }

  loadData() {
    this.appCommunication.loadingOn('Načítavam dáta.');

    const queryDesigner = {
      page: this.table.page,
      pageSize: this.table.pageSize
    };

    this.portfolioService
      .getAllByFilterAdmin(queryDesigner)
      .subscribe(v => {
        this.data = v.items;
        this.table.totalItems = v.totalItems;
        this.appCommunication.loadingOff();
      }, err => {
        console.log(err);
        this.appCommunication.loadingOff();
      });
  }

  openDetail(item: PortfolioItemModel) {
    this.editItemEvent.emit(item);
  }

  showDeleteConfirmation(item: PortfolioItemModel) {
    this.confirmation
      .confirm({
        message: 'Skutočne si prajete odstrániť záznam?',
        acceptLabel: 'Áno',
        rejectLabel: 'Nie',
        accept: () => this.deletePortfolio(item)
      });
  }

  deletePortfolio(item: PortfolioItemModel) {
    this.portfolioService
      .delete(item.id)
      .pipe(first())
      .subscribe({
        next: () => this.loadData()
      });
  }

}
